module.exports = __webpack_public_path__ + "img/san-jose-pool.d761337b.jpg";